import MyAxios from "@/utilize/MyAxios";
import { useQuery } from "@tanstack/react-query";

export default function useGetIntercom() {
  return useQuery({
    queryKey: ["intercomtoken"],
    queryFn: () =>
      MyAxios.get<{
        token: string;
      }>("auth/intercom").then((res) => res.data),
  });
}
